<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      GST Rate
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryGstRateFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGstRateFilterForm"
                            v-model="filtersGstRate.gstStat"
                            :label="filtersGstRateLabel.gstStat"
                            :error-messages="errors.collect('filterGstRate')"
                            data-vv-name="filterGstRate"
                            :data-vv-as="filtersGstRateLabel.gstStat"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearGstRateFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doGstRateFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="gstRateHeaders"
          :items="gstRateItems"
          v-bind:options.sync="paginationGstRate"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsGstRate"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.gstStat }}</td>
              <td>{{ formatPrice(row.item.gstRate) }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignGstRate(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatPrice } from '@/utils/index'
import { removeTime, formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      gstRateHeaders: [
        { text: 'GST Status', value: 'gstStat' },
        { text: 'GST Rate', value: 'gstRate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      totalItemsGstRate: 0,
      gstRateItems: [],
      paginationGstRate: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      filtersGstRate: {
        gstStat: '',
        effDate: null,
        gstType: ''
      },
      filtersGstRateLabel: {
        gstStat: 'GST Status'
      }
    }
  },
  mounted() {
    this.doClearGstRateFilters()
  },
  watch: {
    paginationGstRate: function(value) {
      this.doAssignValue()
      this.fetchGstRateData()
    }
  },
  methods: {
    closeDialog() {
      this.filtersGstRate.gstStat = ''
      this.$emit('close')
    },
    doClearGstRateFilters() {
      this.filtersGstRate.gstStat = ''
      this.doAssignValue()
      this.fetchGstRateData()
    },
    doGstRateFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryGstRateFilterForm').then(result => {
        if (result) {
          this.paginationGstRate.page = 1
          this.doAssignValue()
          this.fetchGstRateData()
        }
      })
    },
    doAssignValue() {
      if (this.gstStat) {
        this.filtersGstRate.gstStat = this.gstStat
      }
      this.filtersGstRate.gstType = this.gstType
      this.filtersGstRate.effDate = formatDisplayDate(removeTime(this.effDate))
    },
    assignGstRate(data) {
      this.$emit('assign-gstRate', data.gstRate)
      this.$emit('assign-gstRate-info', data)
      this.$emit('close')
    },
    formatPrice(data) {
      return formatPrice(data)
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  props: {
    effDate: {
      type: Date,
      default: null
    },
    gstType: {
      type: String,
      default: ''
    },
    gstStat: {
      type: String,
      default: ''
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
